import { request, uploadFile } from "../base";
import type { MusicTrack } from "../social-drafts";

export const adminSocialStudioMusicApi = {
	async listMusicTracks(params?: {
		category?: string;
		includeInactive?: boolean;
	}) {
		const searchParams = new URLSearchParams();
		if (params?.category) searchParams.set("category", params.category);
		if (params?.includeInactive)
			searchParams.set("includeInactive", "true");
		const query = searchParams.toString();
		const url = `/api/admin/social-studio/music-tracks${query ? `?${query}` : ""}`;
		return request<{ tracks: MusicTrack[] }>(url);
	},

	async createMusicTrack(file: File, fields: { name: string; category: string; durationS: string }) {
		return uploadFile<{ track: MusicTrack }>(
			"/api/admin/social-studio/music-tracks",
			file,
			fields,
		);
	},

	async updateMusicTrack(
		id: string,
		data: { name?: string; category?: string; isActive?: boolean },
	) {
		return request<{ track: MusicTrack }>(
			`/api/admin/social-studio/music-tracks/${id}`,
			{
				method: "PUT",
				body: data,
			},
		);
	},

	async deleteMusicTrack(id: string) {
		return request<{ ok: boolean }>(
			`/api/admin/social-studio/music-tracks/${id}`,
			{
				method: "DELETE",
			},
		);
	},
};
